import { render } from "./infoClassificationProperties.vue?vue&type=template&id=49e027a4&scoped=true&ts=true"
import script from "./infoClassificationProperties.vue?vue&type=script&lang=ts"
export * from "./infoClassificationProperties.vue?vue&type=script&lang=ts"

import "./infoClassificationProperties.vue?vue&type=style&index=0&id=49e027a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e027a4"]])

export default __exports__